<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkRedactorSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('wk-articles');
const defaults = ref<any>({
    sectionPage: null,
    quantity: 0
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}
onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Wybór strony]]]')" :invalid-feedback="form.$errors.first('settings.sectionPage')" :state="form.$errors.state('settings.sectionPage')">
        <EditoPageSelector
            v-model="form.settings.sectionPage"
            :module="module"
            label=""
            :preview="false"
            :is-sections-type-only="true"
            class="mb-0"
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Ilość wyświetlanych pozycji]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <IdeoFormInput
            v-model="form.settings.quantity"
            name="redactorQuantity"
            type="text"
            inputmode="numeric"
            title="Wprowadź liczbę od 1 do 3 lub pozostaw puste"
        />
    </IdeoFormGroup>
</template>
